export const USER_MANAGEMENT_GROUP = 'user-management';
